<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23 21.5V25.5H7V21.5" stroke="black" stroke-width="2"/>
<path d="M15 21L15 6M15 6L9 12M15 6L21 12" stroke="black" stroke-width="2"/>
</svg>
